//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    props: {
        caseKey: {
            type: String,
            required: true,
        },
        childClasses: {
            type: String,
            default: '',
        },
        imagePosition: {
            type: String,
            default: 'object-center',
        },
    },
    computed: {
        ...mapState('cases', ['cases']),

        singleCase() {
            return this.cases[this.$i18n.locale].find((item) => item.key === this.caseKey);
        },
    },
};
